import { Button } from '@heroui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserState } from '@/state';

import {
  AccessDeniedContainer,
  AccessDeniedWrapper,
  ContentWrapper,
  Description,
  Title,
} from './AccessDenied.styled';

export const AccessDenied: FC = () => {
  const { t } = useTranslation();
  const { logout, currentUser } = useUserState();
  return (
    <AccessDeniedWrapper>
      <AccessDeniedContainer>
        <ContentWrapper>
          <Title>{t('accessDenied.title')}</Title>
          <Description>
            <strong>
              {currentUser?.email}
            </strong>
            {' '}
            <br />
            {t('accessDenied.message')}
          </Description>
          <Button
            radius="sm"
            onPress={logout}
            size="md"
            variant="bordered"
            color="danger"
            className="mt-5"
          >
            {t('common.logout')}
          </Button>
        </ContentWrapper>
      </AccessDeniedContainer>
    </AccessDeniedWrapper>

  );
};
